// components/common/farbro-location-dropdown.tsx
import { useEffect } from 'react';

import { Dropdown } from 'primereact/dropdown';
import { useSearchParams } from 'react-router-dom';

type Props = {
  /** Array of location strings, e.g., FARBRO_LOCATIONS */
  options: string[];
  /** “l” by default */
  paramKey?: string;
  /** Currently selected value */
  value?: string | null;
  /** Disabled flag */
  disabled?: boolean;
  /** Called after selection changes */
  onChange?: (loc: string | null) => void;
  className?: string;
  placeholder?: string;
};

export default function FarbroLocationDropdown({
  options,
  paramKey = 'l',
  value = null,
  disabled,
  onChange,
  className,
  placeholder = 'Location',
}: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (value) return;
    const urlVal = searchParams.get(paramKey);
    if (urlVal) onChange?.(urlVal);
  }, [value, searchParams, paramKey, onChange]);

  const writeUrl = (loc: string | null) => {
    const next = new URLSearchParams(searchParams);
    if (loc) {
      next.set(paramKey, loc);
    } else {
      next.delete(paramKey);
    }
    setSearchParams(next, { replace: true });
    onChange?.(loc);
  };

  return (
    <Dropdown
      value={value}
      options={options}
      onChange={(e) => writeUrl(e.value ?? null)}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      showClear
    />
  );
}
